module.exports = __webpack_public_path__ + "media/src/images/partners/heidelberg-90e250b64a1f95cb949108cb14ac464a.jpg";